import { useEffect } from 'react';

import { CalculationWidgetForArticles } from '@sravni/osago-calculation-widget/lib/CalculationWidgetForArticles';
import { useBoolean } from '@sravni/react-utils';

import type { CustomOneTabsComponentProps } from '../../helpers/getComponentByTabType';

export const InsuranceOsago = ({
  contentRef,
  setShowPreloader,
  sendMessageToParentWindow,
}: CustomOneTabsComponentProps) => {
  const [eventSent, setSendEvent] = useBoolean(false);

  useEffect(() => {
    setShowPreloader.off();
    sendMessageToParentWindow({ type: 'itemsCount', itemsCount: 1 });
    if (!eventSent) {
      sendMessageToParentWindow({
        type: 'pushEvent',
        event: {
          event: 'adEvent',
          eventCategory: 'ОСАГО',
          eventAction: 'Показ|Оформление заявки',
        },
      });
      setSendEvent.on();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventSent]);

  const handleSubmit = (url: string) => {
    sendMessageToParentWindow({
      type: 'pushEvent',
      event: {
        event: 'mainEvent',
        eventCategory: 'ОСАГО',
        eventAction: 'Переход к оформлению заявки',
      },
    });

    sendMessageToParentWindow({ type: 'generalLinkClick', url });
  };

  return (
    <div ref={contentRef}>
      <CalculationWidgetForArticles onRedirect={handleSubmit} />
    </div>
  );
};
